import { observer } from 'mobx-react-lite'
import { BulkCopyJobsSuccessDialog } from '@/features/jobs/list/components/BulkCopyJobsSuccessDialog'
import { type BulkCopyJobsSuccessDialogViewModel } from './BulkCopyJobsSuccessDialogViewModel'

export interface BulkCopyJobsSuccessDialogContainerProps {
  vm: BulkCopyJobsSuccessDialogViewModel
}

export const BulkCopyJobsSuccessDialogContainer = observer(
  function BulkCopyJobsSuccessDialogContainer({
    vm,
  }: BulkCopyJobsSuccessDialogContainerProps) {
    return (
      <BulkCopyJobsSuccessDialog
        showing={vm.modal.showing}
        jobCount={vm.jobCount}
        onClose={vm.modal.close}
        onStart={vm.start}
      />
    )
  },
)
